import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

export default function useQueryParams() {
  const { search } = useLocation();

  const queryParams = useMemo(
    () => qs.parse(search, { ignoreQueryPrefix: true }),
    [search]
  );

  /**
   * Get a specific query parameter value
   * @param {string} param - The name of the query parameter to retrieve
   * @param {string} [fallback=''] - Fallback value to return if parameter is not found
   * @returns {string} The query parameter value or the fallback value
   */
  const getParam = (param, fallback = '') => queryParams[param] || fallback;

  /**
   * Check if a query parameter exists
   * @param {string} param - The name of the query parameter to check
   * @returns {boolean} True if parameter exists, otherwise false
   */
  const hasParam = param => param in queryParams;

  return {
    queryParams,
    getParam,
    hasParam
  };
}
